// import { useState, useEffect } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import { baseUrl } from "../config/baseUrl"
// import axios from "axios"
// import toastify from "../config/toastify"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faArrowLeft, faQuestionCircle, faSave, faGlobe, faBook } from "@fortawesome/free-solid-svg-icons"

// export default function AddQuestion() {
//     const [formval, setFormval] = useState({
//         // English fields
//         question_english: "",
//         option_a_english: "",
//         option_b_english: "",
//         option_c_english: "",
//         option_d_english: "",
//         option_e_english: "",
//         explanation_english: "",

//         // Hindi fields
//         question_hindi: "",
//         option_A_hindi: "",
//         option_B_hindi: "",
//         option_C_hindi: "",
//         option_D_hindi: "",
//         option_E_hindi: "",
//         explanation_hindi: "",

//         // Bengali fields
//         question_bengali: "",
//         option_1_bengali: "",
//         option_2_bengali: "",
//         option_3_bengali: "",
//         option_4_bengali: "",
//         option_e_bengali: "",
//         explanation_bengali: "",

//         correct_answer: "",
//         subject: "",
//         topic: "",
//         status: "",
//     })

//     const [subjects, setSubjects] = useState([])
//     const [topics, setTopics] = useState([])
//     const [activeLanguage, setActiveLanguage] = useState("en")
//     const [loading, setLoading] = useState(false)
//     const [fetchingData, setFetchingData] = useState(true)

//     const navigate = useNavigate()

//     // Fetch subjects and topics when component mounts
//     useEffect(() => {
//         const fetchData = async () => {
//             setFetchingData(true)
//             try {
//                 // Fetch subjects
//                 const subjectsResponse = await axios.get(`${baseUrl}/subject/list`, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                     },
//                 })

//                 if (subjectsResponse.data && subjectsResponse.data.data) {
//                     setSubjects(subjectsResponse.data.data)
//                 }

//                 // Fetch topics
//                 const topicsResponse = await axios.get(`${baseUrl}/topic/list`, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                     },
//                 })

//                 if (topicsResponse.data && topicsResponse.data.data) {
//                     setTopics(topicsResponse.data.data)
//                 }
//             } catch (error) {
//                 console.error("Error fetching data:", error)
//                 toastify.error("Failed to load subjects or topics")
//             } finally {
//                 setFetchingData(false)
//             }
//         }

//         fetchData()
//     }, [])


//     const changeHandler = (e) => {
//         const { name, value } = e.target;
//         setFormval((prev) => ({
//             ...prev,
//             [name]: value,
//             ...(name === "subject" && { topic: "" }) // Reset topic when subject changes
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault()
//         setLoading(true)

//         // Form validation
//         if (!formval.question_english) {
//             setLoading(false)
//             return toastify.error("English question is required")
//         }
//         if (
//             !formval.option_a_english ||
//             !formval.option_b_english ||
//             !formval.option_c_english ||
//             !formval.option_d_english
//         ) {
//             setLoading(false)
//             return toastify.error("All English options (A-D) are required")
//         }
//         if (!formval.correct_answer) {
//             setLoading(false)
//             return toastify.error("Correct answer is required")
//         }
//         if (!formval.subject) {
//             setLoading(false)
//             return toastify.error("Subject is required")
//         }
//         if (!formval.topic) {
//             setLoading(false)
//             return toastify.error("Topic is required")
//         }
//         if (!formval.status) {
//             setLoading(false)
//             return toastify.error("Status is required")
//         }

//         try {
//             const response = await axios(`${baseUrl}/question`, {
//                 method: "POST",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                     "Content-Type": "application/json",
//                 },
//                 data: formval,
//             })

//             if (!response?.data?.status) {
//                 toastify.error("An error occurred while saving the question")
//                 return
//             }

//             toastify.success("Question added successfully")
//             navigate("/questions")
//         } catch (error) {
//             console.error("Error:", error)
//             toastify.error("Failed to add question")
//         } finally {
//             setLoading(false)
//         }
//     }

//     const languages = [
//         { code: "en", name: "English", flag: "🇺🇸" },
//         { code: "hi", name: "हिंदी", flag: "🇮🇳" },
//         { code: "bn", name: "বাংলা", flag: "🇧🇩" },
//     ]

//     const getFieldNames = (lang) => {
//         switch (lang) {
//             case "en":
//                 return {
//                     question: "question_english",
//                     optionA: "option_a_english",
//                     optionB: "option_b_english",
//                     optionC: "option_c_english",
//                     optionD: "option_d_english",
//                     optionE: "option_e_english",
//                     explanation: "explanation_english",
//                 }
//             case "hi":
//                 return {
//                     question: "question_hindi",
//                     optionA: "option_A_hindi",
//                     optionB: "option_B_hindi",
//                     optionC: "option_C_hindi",
//                     optionD: "option_D_hindi",
//                     optionE: "option_E_hindi",
//                     explanation: "explanation_hindi",
//                 }
//             case "bn":
//                 return {
//                     question: "question_bengali",
//                     optionA: "option_1_bengali",
//                     optionB: "option_2_bengali",
//                     optionC: "option_3_bengali",
//                     optionD: "option_4_bengali",
//                     optionE: "option_e_bengali",
//                     explanation: "explanation_bengali",
//                 }
//             default:
//                 return {}
//         }
//     }

//     // Filter topics based on selected subject
//     // const filteredTopics = formval.subject ? topics.filter((topic) => topic.subject._id === formval.subject) : topics

//     const filteredTopics = formval.subject
//         ? topics.filter((topic) => topic?.subject?._id === formval.subject)
//         : topics;


//     return (
//         <>
//             <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .form-label {
//           font-weight: 600;
//           color: #555;
//           margin-bottom: 0.5rem;
//         }

//         .form-control {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           transition: all 0.3s ease;
//         }

//         .form-control:focus {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
//         }

//         .btn-for-add {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 2rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//         }

//         .btn-for-add:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//         }

//         .btn-for-add:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .btn-info {
//           background: #4facfe;
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//         }

//         .btn-info:hover {
//           background: #2f86fe;
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
//         }

//         .language-tabs {
//           display: flex;
//           gap: 0.5rem;
//           margin-bottom: 2rem;
//           border-bottom: 2px solid #f0f0f0;
//           padding-bottom: 1rem;
//         }

//         .language-tab {
//           padding: 0.75rem 1.5rem;
//           border: 2px solid #e0e0e0;
//           border-radius: 8px;
//           background: white;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .language-tab.active {
//           border-color: #667eea;
//           background: #667eea;
//           color: white;
//         }

//         .language-tab:hover {
//           border-color: #667eea;
//           transform: translateY(-2px);
//         }

//         .language-content {
//           display: none;
//         }

//         .language-content.active {
//           display: block;
//         }

//         .option-container {
//           position: relative;
//           border: 1px solid #ddd;
//           border-radius: 8px;
//           padding: 1rem;
//           margin-bottom: 1rem;
//           transition: all 0.3s ease;
//         }

//         .option-container:hover {
//           border-color: #667eea;
//         }

//         .option-label {
//           position: absolute;
//           top: -10px;
//           left: 10px;
//           background: white;
//           padding: 0 8px;
//           font-weight: 600;
//           color: #667eea;
//           font-size: 0.9rem;
//         }

//         .correct-answer-container {
//           background: rgba(102, 126, 234, 0.1);
//           border-radius: 8px;
//           padding: 1.5rem;
//           margin-bottom: 1.5rem;
//         }

//         .correct-answer-title {
//           font-weight: 700;
//           color: #667eea;
//           margin-bottom: 1rem;
//         }

//         .radio-container {
//           display: flex;
//           gap: 1.5rem;
//           flex-wrap: wrap;
//         }

//         .radio-option {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           cursor: pointer;
//         }

//         .radio-option input[type="radio"] {
//           accent-color: #667eea;
//           width: 18px;
//           height: 18px;
//         }

//         .question-textarea {
//           min-height: 120px;
//           resize: vertical;
//         }

//         .metadata-section {
//           background: rgba(79, 172, 254, 0.1);
//           border-radius: 8px;
//           padding: 1.5rem;
//           margin-bottom: 2rem;
//         }

//         .metadata-title {
//           font-weight: 700;
//           color: #4facfe;
//           margin-bottom: 1rem;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid #f3f3f3;
//           border-top: 2px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//           margin-right: 0.5rem;
//         }

//         .loading-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(255, 255, 255, 0.7);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 10;
//           border-radius: 8px;
//         }

//         .loading-text {
//           font-weight: 600;
//           color: #667eea;
//           margin-left: 0.5rem;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .cards {
//             padding: 1.5rem;
//           }

//           .radio-container {
//             flex-direction: column;
//             gap: 1rem;
//           }

//           .language-tabs {
//             flex-direction: column;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row align-items-center">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                                     Add Question
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/questions">Questions</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Add Question
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end">
//                             <Link to="/questions" className="btn btn-info text-white">
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
//                                 Back
//                             </Link>
//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards edit-usr" style={{ position: "relative" }}>
//                                 {fetchingData && (
//                                     <div className="loading-overlay">
//                                         <div className="loading-spinner"></div>
//                                         <span className="loading-text">Loading subjects and topics...</span>
//                                     </div>
//                                 )}

//                                 <form onSubmit={handleSubmit}>
//                                     {/* Metadata Section */}
//                                     <div className="metadata-section">
//                                         <div className="metadata-title">
//                                             <FontAwesomeIcon icon={faBook} />
//                                             Question Metadata
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="subject" className="form-label">
//                                                     Subject<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="subject"
//                                                     onChange={changeHandler}
//                                                     value={formval?.subject}
//                                                     disabled={fetchingData}
//                                                 >
//                                                     <option value="">Select Subject</option>
//                                                     {subjects.map((subject) => (
//                                                         <option key={subject._id} value={subject._id}>
//                                                             {subject.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="topic" className="form-label">
//                                                     Topic<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="topic"
//                                                     onChange={changeHandler}
//                                                     value={formval?.topic}
//                                                     disabled={fetchingData || !formval.subject}
//                                                 >
//                                                     <option value="">Select Topic</option>
//                                                     {filteredTopics.map((topic) => (
//                                                         <option key={topic._id} value={topic._id}>
//                                                             {topic.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="status" className="form-label">
//                                                     Status<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
//                                                     <option value="">Select Status</option>
//                                                     <option value="active">Active</option>
//                                                     <option value="inactive">Inactive</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Language Tabs */}
//                                     <div className="language-tabs">
//                                         {languages.map((lang) => (
//                                             <div
//                                                 key={lang.code}
//                                                 className={`language-tab ${activeLanguage === lang.code ? "active" : ""}`}
//                                                 onClick={() => setActiveLanguage(lang.code)}
//                                             >
//                                                 <span>{lang.name}</span>
//                                                 <FontAwesomeIcon icon={faGlobe} />
//                                             </div>
//                                         ))}
//                                     </div>

//                                     {/* Language Content */}
//                                     {languages.map((lang) => {
//                                         const fields = getFieldNames(lang.code)
//                                         return (
//                                             <div
//                                                 key={lang.code}
//                                                 className={`language-content ${activeLanguage === lang.code ? "active" : ""}`}
//                                             >
//                                                 <div className="row">
//                                                     <div className="col-lg-12 mb-4">
//                                                         <label htmlFor={fields.question} className="form-label">
//                                                             Question ({lang.name}){lang.code === "en" && <sup className="text-danger">*</sup>}
//                                                         </label>
//                                                         <textarea
//                                                             className="form-control question-textarea"
//                                                             name={fields.question}
//                                                             placeholder={`Enter your question in ${lang.name}`}
//                                                             onChange={changeHandler}
//                                                             value={formval[fields.question]}
//                                                         ></textarea>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option A ({lang.name})</span>
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionA}
//                                                                 placeholder={`Enter option A in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionA]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option B ({lang.name})</span>
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionB}
//                                                                 placeholder={`Enter option B in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionB]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option C ({lang.name})</span>
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionC}
//                                                                 placeholder={`Enter option C in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionC]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option D ({lang.name})</span>
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionD}
//                                                                 placeholder={`Enter option D in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionD]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-12 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option E ({lang.name})</span>
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionE}
//                                                                 placeholder={`Enter option E in ${lang.name} (optional)`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionE]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-12 mb-4">
//                                                         <label htmlFor={fields.explanation} className="form-label">
//                                                             Explanation ({lang.name})
//                                                         </label>
//                                                         <textarea
//                                                             className="form-control"
//                                                             name={fields.explanation}
//                                                             placeholder={`Enter explanation in ${lang.name}`}
//                                                             onChange={changeHandler}
//                                                             value={formval[fields.explanation]}
//                                                             rows="3"
//                                                         ></textarea>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )
//                                     })}

//                                     {/* Correct Answer Section */}
//                                     <div className="correct-answer-container">
//                                         <div className="correct-answer-title">
//                                             Select Correct Answer<sup className="text-danger">*</sup>
//                                         </div>
//                                         <div className="radio-container">
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="A"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "A"}
//                                                 />
//                                                 Option A
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="B"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "B"}
//                                                 />
//                                                 Option B
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="C"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "C"}
//                                                 />
//                                                 Option C
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="D"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "D"}
//                                                 />
//                                                 Option D
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="E"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "E"}
//                                                 />
//                                                 Option E
//                                             </label>
//                                         </div>
//                                     </div>

//                                     <div className="col-lg-12 text-center mt-4">
//                                         <button type="submit" className="btn btn-for-add text-white" disabled={loading || fetchingData}>
//                                             {loading && <div className="loading-spinner"></div>}
//                                             <FontAwesomeIcon icon={faSave} className="me-2" />
//                                             {loading ? "Saving..." : "Save Question"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }
















// "use client"

// import { useState, useEffect, useRef } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import { baseUrl } from "../config/baseUrl"
// import axios from "axios"
// import toastify from "../config/toastify"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//     faArrowLeft,
//     faQuestionCircle,
//     faSave,
//     faGlobe,
//     faBook,
//     faImage,
//     faCalculator,
//     faTimes,
// } from "@fortawesome/free-solid-svg-icons"

// export default function AddQuestion() {
//     const [formval, setFormval] = useState({
//         // English fields
//         question_english: "",
//         option_a_english: "",
//         option_b_english: "",
//         option_c_english: "",
//         option_d_english: "",
//         option_e_english: "",
//         explanation_english: "",

//         // Hindi fields
//         question_hindi: "",
//         option_A_hindi: "",
//         option_B_hindi: "",
//         option_C_hindi: "",
//         option_D_hindi: "",
//         option_E_hindi: "",
//         explanation_hindi: "",

//         // Bengali fields
//         question_bengali: "",
//         option_1_bengali: "",
//         option_2_bengali: "",
//         option_3_bengali: "",
//         option_4_bengali: "",
//         option_e_bengali: "",
//         explanation_bengali: "",

//         correct_answer: "",
//         subject: "",
//         topic: "",
//         status: "",
//         question_type: "standard", // standard or math
//     })

//     const [subjects, setSubjects] = useState([])
//     const [topics, setTopics] = useState([])
//     const [activeLanguage, setActiveLanguage] = useState("en")
//     const [loading, setLoading] = useState(false)
//     const [fetchingData, setFetchingData] = useState(true)
//     const [mathExpression, setMathExpression] = useState("")
//     const [showMathEditor, setShowMathEditor] = useState(false)
//     const [activeField, setActiveField] = useState(null)
//     const [explanationImages, setExplanationImages] = useState({
//         english: [],
//         hindi: [],
//         bengali: [],
//     })
//     const [uploadingImage, setUploadingImage] = useState(false)

//     const fileInputRef = useRef(null)
//     const navigate = useNavigate()

//     // Fetch subjects and topics when component mounts
//     useEffect(() => {
//         const fetchData = async () => {
//             setFetchingData(true)
//             try {
//                 // Fetch subjects
//                 const subjectsResponse = await axios.get(`${baseUrl}/subject/list`, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                     },
//                 })

//                 if (subjectsResponse.data && subjectsResponse.data.data) {
//                     setSubjects(subjectsResponse.data.data)
//                 }

//                 // Fetch topics
//                 const topicsResponse = await axios.get(`${baseUrl}/topic/list`, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                     },
//                 })

//                 if (topicsResponse.data && topicsResponse.data.data) {
//                     setTopics(topicsResponse.data.data)
//                 }
//             } catch (error) {
//                 console.error("Error fetching data:", error)
//                 toastify.error("Failed to load subjects or topics")
//             } finally {
//                 setFetchingData(false)
//             }
//         }

//         fetchData()
//     }, [])

//     // Load KaTeX for math rendering
//     useEffect(() => {
//         const katexCSS = document.createElement("link")
//         katexCSS.rel = "stylesheet"
//         katexCSS.href = "https://cdn.jsdelivr.net/npm/katex@0.16.8/dist/katex.min.css"
//         document.head.appendChild(katexCSS)

//         const katexScript = document.createElement("script")
//         katexScript.src = "https://cdn.jsdelivr.net/npm/katex@0.16.8/dist/katex.min.js"
//         document.head.appendChild(katexScript)

//         return () => {
//             document.head.removeChild(katexCSS)
//             document.head.removeChild(katexScript)
//         }
//     }, [])

//     const changeHandler = (e) => {
//         const { name, value } = e.target
//         setFormval((prev) => ({
//             ...prev,
//             [name]: value,
//             ...(name === "subject" && { topic: "" }),
//         }))
//     }

//     // Math Expression Handler
//     const insertMathExpression = (expression) => {
//         if (activeField && window.katex) {
//             try {
//                 // Validate the expression
//                 window.katex.renderToString(expression, {
//                     throwOnError: true,
//                     displayMode: false,
//                 })

//                 // Insert into active field
//                 const currentValue = formval[activeField] || ""
//                 const newValue = currentValue + ` $$${expression}$$ `

//                 setFormval((prev) => ({
//                     ...prev,
//                     [activeField]: newValue,
//                 }))

//                 setMathExpression("")
//                 setShowMathEditor(false)
//                 toastify.success("Math expression inserted successfully")
//             } catch (error) {
//                 toastify.error("Invalid math expression")
//             }
//         }
//     }

//     // Image Upload Handler for Explanations
//     const handleExplanationImageUpload = async (files, language) => {
//         setUploadingImage(true)
//         const uploadedImages = []

//         for (const file of files) {
//             const formData = new FormData()
//             formData.append("image", file)

//             try {
//                 const response = await axios.post(`${baseUrl}/upload/image`, formData, {
//                     headers: {
//                         Authorization: localStorage.getItem("token"),
//                         "Content-Type": "multipart/form-data",
//                     },
//                 })

//                 if (response.data.success) {
//                     uploadedImages.push({
//                         id: Date.now() + Math.random(),
//                         url: response.data.url,
//                         name: file.name,
//                     })
//                 }
//             } catch (error) {
//                 toastify.error(`Failed to upload ${file.name}`)
//             }
//         }

//         setExplanationImages((prev) => ({
//             ...prev,
//             [language]: [...prev[language], ...uploadedImages],
//         }))
//         setUploadingImage(false)
//     }

//     // Remove Image Handler
//     const removeExplanationImage = (imageId, language) => {
//         setExplanationImages((prev) => ({
//             ...prev,
//             [language]: prev[language].filter((img) => img.id !== imageId),
//         }))
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()
//         setLoading(true)

//         // Form validation
//         if (!formval.question_english) {
//             setLoading(false)
//             return toastify.error("English question is required")
//         }
//         if (
//             !formval.option_a_english ||
//             !formval.option_b_english ||
//             !formval.option_c_english ||
//             !formval.option_d_english
//         ) {
//             setLoading(false)
//             return toastify.error("All English options (A-D) are required")
//         }
//         if (!formval.correct_answer) {
//             setLoading(false)
//             return toastify.error("Correct answer is required")
//         }
//         if (!formval.subject) {
//             setLoading(false)
//             return toastify.error("Subject is required")
//         }
//         if (!formval.topic) {
//             setLoading(false)
//             return toastify.error("Topic is required")
//         }
//         if (!formval.status) {
//             setLoading(false)
//             return toastify.error("Status is required")
//         }

//         try {
//             const submitData = {
//                 ...formval,
//                 explanation_images: explanationImages,
//             }

//             const response = await axios(`${baseUrl}/question`, {
//                 method: "POST",
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                     "Content-Type": "application/json",
//                 },
//                 data: submitData,
//             })

//             if (!response?.data?.status) {
//                 toastify.error("An error occurred while saving the question")
//                 return
//             }

//             toastify.success("Question added successfully")
//             navigate("/questions")
//         } catch (error) {
//             console.error("Error:", error)
//             toastify.error("Failed to add question")
//         } finally {
//             setLoading(false)
//         }
//     }

//     const languages = [
//         { code: "en", name: "English", flag: "🇺🇸" },
//         { code: "hi", name: "हिंदी", flag: "🇮🇳" },
//         { code: "bn", name: "বাংলা", flag: "🇧🇩" },
//     ]

//     const getFieldNames = (lang) => {
//         switch (lang) {
//             case "en":
//                 return {
//                     question: "question_english",
//                     optionA: "option_a_english",
//                     optionB: "option_b_english",
//                     optionC: "option_c_english",
//                     optionD: "option_d_english",
//                     optionE: "option_e_english",
//                     explanation: "explanation_english",
//                 }
//             case "hi":
//                 return {
//                     question: "question_hindi",
//                     optionA: "option_A_hindi",
//                     optionB: "option_B_hindi",
//                     optionC: "option_C_hindi",
//                     optionD: "option_D_hindi",
//                     optionE: "option_E_hindi",
//                     explanation: "explanation_hindi",
//                 }
//             case "bn":
//                 return {
//                     question: "question_bengali",
//                     optionA: "option_1_bengali",
//                     optionB: "option_2_bengali",
//                     optionC: "option_3_bengali",
//                     optionD: "option_4_bengali",
//                     optionE: "option_e_bengali",
//                     explanation: "explanation_bengali",
//                 }
//             default:
//                 return {}
//         }
//     }

//     // const filteredTopics = formval.subject ? topics.filter((topic) => topic.subject === formval.subject) : topics
//     // Filter topics based on selected subject
//     // const filteredTopics = formval.subject ? topics.filter((topic) => topic.subject._id === formval.subject) : topics

//     const filteredTopics = formval.subject
//         ? topics.filter((topic) => topic?.subject?._id === formval.subject)
//         : topics;


//     const getLanguageKey = (lang) => {
//         switch (lang) {
//             case "en":
//                 return "english"
//             case "hi":
//                 return "hindi"
//             case "bn":
//                 return "bengali"
//             default:
//                 return "english"
//         }
//     }

//     return (
//         <>
//             <style jsx>{`
//         .main-sec {
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           min-height: 100vh;
//           padding: 2rem 0;
//         }

//         .dashboard-title {
//           margin-bottom: 1.5rem;
//         }

//         .dash-head {
//           color: #333;
//           font-size: 1.8rem;
//           font-weight: 700;
//           margin: 0;
//         }

//         .cards {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           margin-bottom: 2rem;
//         }

//         .form-label {
//           font-weight: 600;
//           color: #555;
//           margin-bottom: 0.5rem;
//         }

//         .form-control {
//           border-radius: 8px;
//           border: 1px solid #ddd;
//           padding: 0.75rem 1rem;
//           transition: all 0.3s ease;
//         }

//         .form-control:focus {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.25);
//         }

//         .btn-for-add {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 2rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//         }

//         .btn-for-add:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
//         }

//         .btn-for-add:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .btn-info {
//           background: #4facfe;
//           border: none;
//           border-radius: 8px;
//           padding: 0.75rem 1.5rem;
//           font-weight: 600;
//           transition: all 0.3s ease;
//         }

//         .btn-info:hover {
//           background: #2f86fe;
//           transform: translateY(-2px);
//           box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
//         }

//         .question-type-tabs {
//           display: flex;
//           gap: 0.5rem;
//           margin-bottom: 2rem;
//           border-bottom: 2px solid #f0f0f0;
//           padding-bottom: 1rem;
//         }

//         .question-type-tab {
//           padding: 0.75rem 1.5rem;
//           border: 2px solid #e0e0e0;
//           border-radius: 8px;
//           background: white;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .question-type-tab.active {
//           border-color: #667eea;
//           background: #667eea;
//           color: white;
//         }

//         .language-tabs {
//           display: flex;
//           gap: 0.5rem;
//           margin-bottom: 2rem;
//           border-bottom: 2px solid #f0f0f0;
//           padding-bottom: 1rem;
//         }

//         .language-tab {
//           padding: 0.75rem 1.5rem;
//           border: 2px solid #e0e0e0;
//           border-radius: 8px;
//           background: white;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .language-tab.active {
//           border-color: #667eea;
//           background: #667eea;
//           color: white;
//         }

//         .language-tab:hover {
//           border-color: #667eea;
//           transform: translateY(-2px);
//         }

//         .language-content {
//           display: none;
//         }

//         .language-content.active {
//           display: block;
//         }

//         .option-container {
//           position: relative;
//           border: 1px solid #ddd;
//           border-radius: 8px;
//           padding: 1rem;
//           margin-bottom: 1rem;
//           transition: all 0.3s ease;
//         }

//         .option-container:hover {
//           border-color: #667eea;
//         }

//         .option-label {
//           position: absolute;
//           top: -10px;
//           left: 10px;
//           background: white;
//           padding: 0 8px;
//           font-weight: 600;
//           color: #667eea;
//           font-size: 0.9rem;
//         }

//         .correct-answer-container {
//           background: rgba(102, 126, 234, 0.1);
//           border-radius: 8px;
//           padding: 1.5rem;
//           margin-bottom: 1.5rem;
//         }

//         .correct-answer-title {
//           font-weight: 700;
//           color: #667eea;
//           margin-bottom: 1rem;
//         }

//         .radio-container {
//           display: flex;
//           gap: 1.5rem;
//           flex-wrap: wrap;
//         }

//         .radio-option {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           cursor: pointer;
//         }

//         .radio-option input[type="radio"] {
//           accent-color: #667eea;
//           width: 18px;
//           height: 18px;
//         }

//         .question-textarea {
//           min-height: 120px;
//           resize: vertical;
//         }

//         .metadata-section {
//           background: rgba(79, 172, 254, 0.1);
//           border-radius: 8px;
//           padding: 1.5rem;
//           margin-bottom: 2rem;
//         }

//         .metadata-title {
//           font-weight: 700;
//           color: #4facfe;
//           margin-bottom: 1rem;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .math-toolbar {
//           display: flex;
//           gap: 0.5rem;
//           margin-bottom: 0.5rem;
//           flex-wrap: wrap;
//         }

//         .math-btn {
//           padding: 0.25rem 0.5rem;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           background: white;
//           cursor: pointer;
//           font-size: 0.85rem;
//           transition: all 0.3s ease;
//         }

//         .math-btn:hover {
//           background: #667eea;
//           color: white;
//           border-color: #667eea;
//         }

//         .math-editor-modal {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.5);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .math-editor-content {
//           background: white;
//           border-radius: 15px;
//           padding: 2rem;
//           width: 90%;
//           max-width: 600px;
//           max-height: 80vh;
//           overflow-y: auto;
//         }

//         .math-symbols {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
//           gap: 0.5rem;
//           margin: 1rem 0;
//         }

//         .math-symbol {
//           padding: 0.75rem 0.5rem;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           text-align: center;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           font-family: 'KaTeX_Main', 'Times New Roman', serif;
//         }

//         .math-symbol:hover {
//           background: #667eea;
//           color: white;
//         }

//         .explanation-section {
//           position: relative;
//         }

//         .explanation-images {
//           display: flex;
//           gap: 1rem;
//           flex-wrap: wrap;
//           margin-top: 1rem;
//         }

//         .explanation-image {
//           position: relative;
//           width: 100px;
//           height: 100px;
//           border-radius: 8px;
//           overflow: hidden;
//           border: 2px solid #ddd;
//         }

//         .explanation-image img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .remove-image {
//           position: absolute;
//           top: 5px;
//           right: 5px;
//           background: #ef5350;
//           color: white;
//           border: none;
//           border-radius: 50%;
//           width: 20px;
//           height: 20px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           font-size: 12px;
//         }

//         .image-upload-btn {
//           background: #28a745;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           padding: 0.5rem 1rem;
//           cursor: pointer;
//           font-size: 0.85rem;
//           margin-left: 0.5rem;
//         }

//         .image-upload-btn:hover {
//           background: #218838;
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid #f3f3f3;
//           border-top: 2px solid #667eea;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//           margin-right: 0.5rem;
//         }

//         .loading-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(255, 255, 255, 0.7);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 10;
//           border-radius: 8px;
//         }

//         .loading-text {
//           font-weight: 600;
//           color: #667eea;
//           margin-left: 0.5rem;
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @media (max-width: 768px) {
//           .cards {
//             padding: 1.5rem;
//           }

//           .radio-container {
//             flex-direction: column;
//             gap: 1rem;
//           }

//           .language-tabs, .question-type-tabs {
//             flex-direction: column;
//           }

//           .math-symbols {
//             grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
//           }

//           .math-toolbar {
//             justify-content: center;
//           }
//         }
//       `}</style>

//             <section className="main-sec">
//                 <div className="container">
//                     <div className="row align-items-center">
//                         <div className="col-lg-6">
//                             <div className="dashboard-title">
//                                 <h4 className="dash-head">
//                                     <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
//                                     Add Question
//                                 </h4>
//                             </div>
//                             <div className="custom-bredcump">
//                                 <nav aria-label="breadcrumb">
//                                     <ol className="breadcrumb">
//                                         <li className="breadcrumb-item">
//                                             <Link to="/">Dashboard</Link>
//                                         </li>
//                                         <li className="breadcrumb-item">
//                                             <Link to="/questions">Questions</Link>
//                                         </li>
//                                         <li className="breadcrumb-item active" aria-current="page">
//                                             Add Question
//                                         </li>
//                                     </ol>
//                                 </nav>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 d-flex justify-content-end">
//                             <Link to="/questions" className="btn btn-info text-white">
//                                 <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
//                                 Back
//                             </Link>
//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="col-lg-12">
//                             <div className="cards edit-usr" style={{ position: "relative" }}>
//                                 {fetchingData && (
//                                     <div className="loading-overlay">
//                                         <div className="loading-spinner"></div>
//                                         <span className="loading-text">Loading subjects and topics...</span>
//                                     </div>
//                                 )}

//                                 <form onSubmit={handleSubmit}>
//                                     {/* Question Type Selection */}
//                                     <div className="question-type-tabs">
//                                         <div
//                                             className={`question-type-tab ${formval.question_type === "standard" ? "active" : ""}`}
//                                             onClick={() => setFormval((prev) => ({ ...prev, question_type: "standard" }))}
//                                         >
//                                             <FontAwesomeIcon icon={faQuestionCircle} />
//                                             <span>Standard Question</span>
//                                         </div>
//                                         <div
//                                             className={`question-type-tab ${formval.question_type === "math" ? "active" : ""}`}
//                                             onClick={() => setFormval((prev) => ({ ...prev, question_type: "math" }))}
//                                         >
//                                             <FontAwesomeIcon icon={faCalculator} />
//                                             <span>Math Question</span>
//                                         </div>
//                                     </div>

//                                     {/* Metadata Section */}
//                                     <div className="metadata-section">
//                                         <div className="metadata-title">
//                                             <FontAwesomeIcon icon={faBook} />
//                                             Question Metadata
//                                         </div>
//                                         <div className="row">
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="subject" className="form-label">
//                                                     Subject<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="subject"
//                                                     onChange={changeHandler}
//                                                     value={formval?.subject}
//                                                     disabled={fetchingData}
//                                                 >
//                                                     <option value="">Select Subject</option>
//                                                     {subjects.map((subject) => (
//                                                         <option key={subject._id} value={subject._id}>
//                                                             {subject.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="topic" className="form-label">
//                                                     Topic<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select
//                                                     className="form-control"
//                                                     name="topic"
//                                                     onChange={changeHandler}
//                                                     value={formval?.topic}
//                                                     disabled={fetchingData || !formval.subject}
//                                                 >
//                                                     <option value="">Select Topic</option>
//                                                     {filteredTopics.map((topic) => (
//                                                         <option key={topic._id} value={topic._id}>
//                                                             {topic.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             <div className="col-lg-4 mb-3">
//                                                 <label htmlFor="status" className="form-label">
//                                                     Status<sup className="text-danger">*</sup>
//                                                 </label>
//                                                 <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
//                                                     <option value="">Select Status</option>
//                                                     <option value="active">Active</option>
//                                                     <option value="inactive">Inactive</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Language Tabs */}
//                                     <div className="language-tabs">
//                                         {languages.map((lang) => (
//                                             <div
//                                                 key={lang.code}
//                                                 className={`language-tab ${activeLanguage === lang.code ? "active" : ""}`}
//                                                 onClick={() => setActiveLanguage(lang.code)}
//                                             >
//                                                 <span>{lang.flag}</span>
//                                                 <span>{lang.name}</span>
//                                                 <FontAwesomeIcon icon={faGlobe} />
//                                             </div>
//                                         ))}
//                                     </div>

//                                     {/* Language Content */}
//                                     {languages.map((lang) => {
//                                         const fields = getFieldNames(lang.code)
//                                         const languageKey = getLanguageKey(lang.code)
//                                         return (
//                                             <div
//                                                 key={lang.code}
//                                                 className={`language-content ${activeLanguage === lang.code ? "active" : ""}`}
//                                             >
//                                                 <div className="row">
//                                                     <div className="col-lg-12 mb-4">
//                                                         <label htmlFor={fields.question} className="form-label">
//                                                             Question ({lang.name}){lang.code === "en" && <sup className="text-danger">*</sup>}
//                                                         </label>
//                                                         {formval.question_type === "math" && (
//                                                             <div className="math-toolbar">
//                                                                 <button
//                                                                     type="button"
//                                                                     className="math-btn"
//                                                                     onClick={() => {
//                                                                         setActiveField(fields.question)
//                                                                         setShowMathEditor(true)
//                                                                     }}
//                                                                 >
//                                                                     <FontAwesomeIcon icon={faCalculator} className="me-1" />
//                                                                     Add Math
//                                                                 </button>
//                                                             </div>
//                                                         )}
//                                                         <textarea
//                                                             className="form-control question-textarea"
//                                                             name={fields.question}
//                                                             placeholder={`Enter your question in ${lang.name}${formval.question_type === "math" ? " (Use $$expression$$ for math)" : ""
//                                                                 }`}
//                                                             onChange={changeHandler}
//                                                             value={formval[fields.question]}
//                                                         ></textarea>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option A ({lang.name})</span>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.optionA)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionA}
//                                                                 placeholder={`Enter option A in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionA]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option B ({lang.name})</span>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.optionB)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionB}
//                                                                 placeholder={`Enter option B in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionB]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option C ({lang.name})</span>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.optionC)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionC}
//                                                                 placeholder={`Enter option C in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionC]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-6 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option D ({lang.name})</span>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.optionD)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionD}
//                                                                 placeholder={`Enter option D in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionD]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-12 mb-4">
//                                                         <div className="option-container">
//                                                             <span className="option-label">Option E ({lang.name}) - Optional</span>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.optionE)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} />
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <input
//                                                                 type="text"
//                                                                 className="form-control"
//                                                                 name={fields.optionE}
//                                                                 placeholder={`Enter option E in ${lang.name} (optional)`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.optionE]}
//                                                             />
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-lg-12 mb-4">
//                                                         <div className="explanation-section">
//                                                             <label htmlFor={fields.explanation} className="form-label">
//                                                                 Explanation ({lang.name})
//                                                                 <button
//                                                                     type="button"
//                                                                     className="image-upload-btn"
//                                                                     onClick={() => {
//                                                                         const input = document.createElement("input")
//                                                                         input.type = "file"
//                                                                         input.multiple = true
//                                                                         input.accept = "image/*"
//                                                                         input.onchange = (e) =>
//                                                                             handleExplanationImageUpload(Array.from(e.target.files), languageKey)
//                                                                         input.click()
//                                                                     }}
//                                                                     disabled={uploadingImage}
//                                                                 >
//                                                                     <FontAwesomeIcon icon={faImage} className="me-1" />
//                                                                     {uploadingImage ? "Uploading..." : "Add Image"}
//                                                                 </button>
//                                                             </label>
//                                                             {formval.question_type === "math" && (
//                                                                 <div className="math-toolbar">
//                                                                     <button
//                                                                         type="button"
//                                                                         className="math-btn"
//                                                                         onClick={() => {
//                                                                             setActiveField(fields.explanation)
//                                                                             setShowMathEditor(true)
//                                                                         }}
//                                                                     >
//                                                                         <FontAwesomeIcon icon={faCalculator} className="me-1" />
//                                                                         Add Math
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                             <textarea
//                                                                 className="form-control"
//                                                                 name={fields.explanation}
//                                                                 placeholder={`Enter explanation in ${lang.name}`}
//                                                                 onChange={changeHandler}
//                                                                 value={formval[fields.explanation]}
//                                                                 rows="3"
//                                                             ></textarea>

//                                                             {explanationImages[languageKey] && explanationImages[languageKey].length > 0 && (
//                                                                 <div className="explanation-images">
//                                                                     {explanationImages[languageKey].map((image) => (
//                                                                         <div key={image.id} className="explanation-image">
//                                                                             <img src={image.url || "/placeholder.svg"} alt={image.name} />
//                                                                             <button
//                                                                                 type="button"
//                                                                                 className="remove-image"
//                                                                                 onClick={() => removeExplanationImage(image.id, languageKey)}
//                                                                             >
//                                                                                 <FontAwesomeIcon icon={faTimes} />
//                                                                             </button>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )
//                                     })}

//                                     {/* Correct Answer Section */}
//                                     <div className="correct-answer-container">
//                                         <div className="correct-answer-title">
//                                             Select Correct Answer<sup className="text-danger">*</sup>
//                                         </div>
//                                         <div className="radio-container">
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="A"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "A"}
//                                                 />
//                                                 Option A
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="B"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "B"}
//                                                 />
//                                                 Option B
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="C"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "C"}
//                                                 />
//                                                 Option C
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="D"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "D"}
//                                                 />
//                                                 Option D
//                                             </label>
//                                             <label className="radio-option">
//                                                 <input
//                                                     type="radio"
//                                                     name="correct_answer"
//                                                     value="E"
//                                                     onChange={changeHandler}
//                                                     checked={formval.correct_answer === "E"}
//                                                 />
//                                                 Option E
//                                             </label>
//                                         </div>
//                                     </div>

//                                     <div className="col-lg-12 text-center mt-4">
//                                         <button type="submit" className="btn btn-for-add text-white" disabled={loading || fetchingData}>
//                                             {loading && <div className="loading-spinner"></div>}
//                                             <FontAwesomeIcon icon={faSave} className="me-2" />
//                                             {loading ? "Saving..." : "Save Question"}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Math Editor Modal */}
//                 {showMathEditor && (
//                     <div className="math-editor-modal">
//                         <div className="math-editor-content">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                 <h5>Math Expression Editor</h5>
//                                 <button
//                                     type="button"
//                                     className="btn btn-sm btn-outline-secondary"
//                                     onClick={() => setShowMathEditor(false)}
//                                 >
//                                     <FontAwesomeIcon icon={faTimes} />
//                                 </button>
//                             </div>

//                             <div className="mb-3">
//                                 <label className="form-label">LaTeX Expression</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={mathExpression}
//                                     onChange={(e) => setMathExpression(e.target.value)}
//                                     placeholder="Enter LaTeX expression (e.g., x^2 + y^2 = z^2)"
//                                 />
//                                 {/* <small className="text-muted">
//                                     Use LaTeX syntax. Example: x^2 for x², \frac{a}
//                                     {b} for fractions, \sqrt{x} for square root
//                                 </small> */}
//                             </div>

//                             <div className="math-symbols">
//                                 {[
//                                     { symbol: "\\alpha", display: "α" },
//                                     { symbol: "\\beta", display: "β" },
//                                     { symbol: "\\gamma", display: "γ" },
//                                     { symbol: "\\delta", display: "δ" },
//                                     { symbol: "\\pi", display: "π" },
//                                     { symbol: "\\theta", display: "θ" },
//                                     { symbol: "\\lambda", display: "λ" },
//                                     { symbol: "\\mu", display: "μ" },
//                                     { symbol: "\\sum", display: "Σ" },
//                                     { symbol: "\\int", display: "∫" },
//                                     { symbol: "\\frac{a}{b}", display: "a/b" },
//                                     { symbol: "\\sqrt{x}", display: "√x" },
//                                     { symbol: "x^2", display: "x²" },
//                                     { symbol: "x_1", display: "x₁" },
//                                     { symbol: "\\sin", display: "sin" },
//                                     { symbol: "\\cos", display: "cos" },
//                                     { symbol: "\\tan", display: "tan" },
//                                     { symbol: "\\log", display: "log" },
//                                     { symbol: "\\ln", display: "ln" },
//                                     { symbol: "\\infty", display: "∞" },
//                                     { symbol: "\\pm", display: "±" },
//                                     { symbol: "\\times", display: "×" },
//                                     { symbol: "\\div", display: "÷" },
//                                     { symbol: "\\leq", display: "≤" },
//                                     { symbol: "\\geq", display: "≥" },
//                                     { symbol: "\\neq", display: "≠" },
//                                     { symbol: "\\approx", display: "≈" },
//                                     { symbol: "\\rightarrow", display: "→" },
//                                 ].map((item) => (
//                                     <div
//                                         key={item.symbol}
//                                         className="math-symbol"
//                                         onClick={() => setMathExpression((prev) => prev + item.symbol)}
//                                         title={item.symbol}
//                                     >
//                                         {item.display}
//                                     </div>
//                                 ))}
//                             </div>

//                             <div className="d-flex gap-2 justify-content-end">
//                                 <button type="button" className="btn btn-secondary" onClick={() => setShowMathEditor(false)}>
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     onClick={() => insertMathExpression(mathExpression)}
//                                     disabled={!mathExpression.trim()}
//                                 >
//                                     Insert Expression
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </section>
//         </>
//     )
// }











































"use client"

import React, { useState, useEffect, useRef, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { baseUrl } from "../config/baseUrl"
import axios from "axios"
import toastify from "../config/toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faArrowLeft,
    faQuestionCircle,
    faSave,
    faGlobe,
    faBook,
    faCalculator,
    faTimes,
    faFileText,
} from "@fortawesome/free-solid-svg-icons"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import { toast } from "react-toastify"

export default function AddQuestion() {
    const [formval, setFormval] = useState({
        // English fields
        question_english: "",
        option_a_english: "",
        option_b_english: "",
        option_c_english: "",
        option_d_english: "",
        option_e_english: "",
        explanation_english: "",
        passage_english: "",

        // Hindi fields
        question_hindi: "",
        option_A_hindi: "",
        option_B_hindi: "",
        option_C_hindi: "",
        option_D_hindi: "",
        option_E_hindi: "",
        explanation_hindi: "",
        passage_hindi: "",

        // Bengali fields
        question_bengali: "",
        option_1_bengali: "",
        option_2_bengali: "",
        option_3_bengali: "",
        option_4_bengali: "",
        option_e_bengali: "",
        explanation_bengali: "",
        passage_bengali: "",

        correct_answer: "",
        subject: "",
        topic: "",
        status: "",
        question_type: "standard", // standard, math, or passage
    })

    const [subjects, setSubjects] = useState([])
    const [topics, setTopics] = useState([])
    const [activeLanguage, setActiveLanguage] = useState("en")
    const [loading, setLoading] = useState(false)
    const [fetchingData, setFetchingData] = useState(true)
    const [mathExpression, setMathExpression] = useState("")
    const [showMathEditor, setShowMathEditor] = useState(false)
    const [activeField, setActiveField] = useState(null)

    const fileInputRef = useRef(null)
    const navigate = useNavigate()

    // ReactQuill modules configuration
    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["link", "image", "video"],
            ["clean"],
            ["formula"], // For math formulas
        ],
    }

    const quillFormats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "script",
        "indent",
        "direction",
        "size",
        "color",
        "background",
        "font",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ]

    // Fetch subjects and topics when component mounts
    useEffect(() => {
        const fetchData = async () => {
            setFetchingData(true)
            try {
                // Fetch subjects
                const subjectsResponse = await axios.get(`${baseUrl}/subject/list`, {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                })

                if (subjectsResponse.data && subjectsResponse.data.data) {
                    setSubjects(subjectsResponse.data.data)
                }

                // Fetch topics
                const topicsResponse = await axios.get(`${baseUrl}/topic/list`, {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                })

                if (topicsResponse.data && topicsResponse.data.data) {
                    setTopics(topicsResponse.data.data)
                }
            } catch (error) {
                console.error("Error fetching data:", error)
                toastify.error("Failed to load subjects or topics")
            } finally {
                setFetchingData(false)
            }
        }

        fetchData()
    }, [])

    // Load KaTeX for math rendering
    useEffect(() => {
        const katexCSS = document.createElement("link")
        katexCSS.rel = "stylesheet"
        katexCSS.href = "https://cdn.jsdelivr.net/npm/katex@0.16.8/dist/katex.min.css"
        document.head.appendChild(katexCSS)

        const katexScript = document.createElement("script")
        katexScript.src = "https://cdn.jsdelivr.net/npm/katex@0.16.8/dist/katex.min.js"
        document.head.appendChild(katexScript)

        return () => {
            document.head.removeChild(katexCSS)
            document.head.removeChild(katexScript)
        }
    }, [])

    const changeHandler = (e) => {
        const { name, value } = e.target
        setFormval((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "subject" && { topic: "" }),
        }))
    }

    // Handle ReactQuill changes
    const handleQuillChange = (content, fieldName) => {
        setFormval((prev) => ({
            ...prev,
            [fieldName]: content,
        }))
    }

    // Math Expression Handler
    const insertMathExpression = (expression) => {
        if (activeField && window.katex) {
            try {
                // Validate the expression
                window.katex.renderToString(expression, {
                    throwOnError: true,
                    displayMode: false,
                })

                // Insert into active field
                const currentValue = formval[activeField] || ""
                const newValue = currentValue + ` $$${expression}$$ `

                setFormval((prev) => ({
                    ...prev,
                    [activeField]: newValue,
                }))

                setMathExpression("")
                setShowMathEditor(false)
                // toastify.success("Math expression inserted successfully")
            } catch (error) {
                toastify.error("Invalid math expression")
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        // Form validation
        if (!formval.question_english) {
            setLoading(false)
            return toastify.error("English question is required")
        }
        if (
            !formval.option_a_english ||
            !formval.option_b_english ||
            !formval.option_c_english ||
            !formval.option_d_english
        ) {
            setLoading(false)
            return toastify.error("All English options (A-D) are required")
        }
        if (!formval.correct_answer) {
            setLoading(false)
            return toastify.error("Correct answer is required")
        }
        if (!formval.subject) {
            setLoading(false)
            return toastify.error("Subject is required")
        }
        if (!formval.topic) {
            setLoading(false)
            return toastify.error("Topic is required")
        }
        if (!formval.status) {
            setLoading(false)
            return toastify.error("Status is required")
        }

        // Additional validation for passage type
        if (formval.question_type === "passage" && !formval.passage_english) {
            setLoading(false)
            return toastify.error("English passage is required for passage-based questions")
        }

        try {
            const response = await axios(`${baseUrl}/question`, {
                method: "POST",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
                data: formval,
            })

            if (!response.data?.message === "Question added successfully") {
                toastify.error("An error occurred while saving the question")
                return
            }

            toastify.success("Question added successfully")
            navigate("/questions")
        } catch (error) {
            console.error("Error:", error)
            toastify.error("Failed to add question")
        } finally {
            setLoading(false)
        }
    }

    const languages = [
        { code: "en", name: "English", flag: "🇺🇸" },
        { code: "hi", name: "हिंदी", flag: "🇮🇳" },
        { code: "bn", name: "বাংলা", flag: "🇧🇩" },
    ]

    const getFieldNames = (lang) => {
        switch (lang) {
            case "en":
                return {
                    question: "question_english",
                    optionA: "option_a_english",
                    optionB: "option_b_english",
                    optionC: "option_c_english",
                    optionD: "option_d_english",
                    optionE: "option_e_english",
                    explanation: "explanation_english",
                    passage: "passage_english",
                }
            case "hi":
                return {
                    question: "question_hindi",
                    optionA: "option_A_hindi",
                    optionB: "option_B_hindi",
                    optionC: "option_C_hindi",
                    optionD: "option_D_hindi",
                    optionE: "option_E_hindi",
                    explanation: "explanation_hindi",
                    passage: "passage_hindi",
                }
            case "bn":
                return {
                    question: "question_bengali",
                    optionA: "option_1_bengali",
                    optionB: "option_2_bengali",
                    optionC: "option_3_bengali",
                    optionD: "option_4_bengali",
                    optionE: "option_e_bengali",
                    explanation: "explanation_bengali",
                    passage: "passage_bengali",
                }
            default:
                return {}
        }
    }

    const filteredTopics = formval.subject ? topics.filter((topic) => topic?.subject?._id === formval.subject) : topics

    const getLanguageKey = (lang) => {
        switch (lang) {
            case "en":
                return "english"
            case "hi":
                return "hindi"
            case "bn":
                return "bengali"
            default:
                return "english"
        }
    }


    return (
        <>
            <section className="main-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="dashboard-title">
                                <h4 className="dash-head">
                                    <FontAwesomeIcon icon={faQuestionCircle} className="me-2" />
                                    Add Question
                                </h4>
                            </div>
                            <div className="custom-bredcump">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/questions">Questions</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Add Question
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-end">
                            <Link to="/questions" className="btn btn-info text-white">
                                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                                Back
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cards edit-usr" style={{ position: "relative" }}>
                                {fetchingData && (
                                    <div className="loading-overlay">
                                        <div className="loading-spinner"></div>
                                        <span className="loading-text">Loading subjects and topics...</span>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    {/* Question Type Selection */}
                                    <div className="question-type-tabs">
                                        <div
                                            className={`question-type-tab ${formval.question_type === "standard" ? "active" : ""}`}
                                            onClick={() => setFormval((prev) => ({ ...prev, question_type: "standard" }))}
                                        >
                                            <FontAwesomeIcon icon={faQuestionCircle} />
                                            <span>Standard Question</span>
                                        </div>
                                        <div
                                            className={`question-type-tab ${formval.question_type === "math" ? "active" : ""}`}
                                            onClick={() => setFormval((prev) => ({ ...prev, question_type: "math" }))}
                                        >
                                            <FontAwesomeIcon icon={faCalculator} />
                                            <span>Math Question</span>
                                        </div>
                                        <div
                                            className={`question-type-tab ${formval.question_type === "passage" ? "active" : ""}`}
                                            onClick={() => setFormval((prev) => ({ ...prev, question_type: "passage" }))}
                                        >
                                            <FontAwesomeIcon icon={faFileText} />
                                            <span>Passage Question</span>
                                        </div>
                                    </div>

                                    {/* Metadata Section */}
                                    <div className="metadata-section">
                                        <div className="metadata-title">
                                            <FontAwesomeIcon icon={faBook} />
                                            Question Metadata
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4 mb-3">
                                                <label htmlFor="subject" className="form-label">
                                                    Subject<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="subject"
                                                    onChange={changeHandler}
                                                    value={formval?.subject}
                                                    disabled={fetchingData}
                                                >
                                                    <option value="">Select Subject</option>
                                                    {subjects.map((subject) => (
                                                        <option key={subject._id} value={subject._id}>
                                                            {subject.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-4 mb-3">
                                                <label htmlFor="topic" className="form-label">
                                                    Topic<sup className="text-danger">*</sup>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="topic"
                                                    onChange={changeHandler}
                                                    value={formval?.topic}
                                                    disabled={fetchingData || !formval.subject}
                                                >
                                                    <option value="">Select Topic</option>
                                                    {filteredTopics.map((topic) => (
                                                        <option key={topic._id} value={topic._id}>
                                                            {topic.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-lg-4 mb-3">
                                                <label htmlFor="status" className="form-label">
                                                    Status<sup className="text-danger">*</sup>
                                                </label>
                                                <select className="form-control" name="status" onChange={changeHandler} value={formval?.status}>
                                                    <option value="">Select Status</option>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Passage Section - Only show for passage type */}
                                    {formval.question_type === "passage" && (
                                        <div className="passage-section">
                                            <div className="passage-title">
                                                <FontAwesomeIcon icon={faFileText} />
                                                Reading Passage
                                            </div>

                                            {/* Language Tabs for Passage */}
                                            <div className="language-tabs">
                                                {languages.map((lang) => (
                                                    <div
                                                        key={lang.code}
                                                        className={`language-tab ${activeLanguage === lang.code ? "active" : ""}`}
                                                        onClick={() => setActiveLanguage(lang.code)}
                                                    >
                                                        <span>{lang.flag}</span>
                                                        <span>{lang.name}</span>
                                                        <FontAwesomeIcon icon={faGlobe} />
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Passage Content for each language */}
                                            {languages.map((lang) => {
                                                const fields = getFieldNames(lang.code)
                                                return (
                                                    <div
                                                        key={lang.code}
                                                        className={`language-content ${activeLanguage === lang.code ? "active" : ""}`}
                                                    >
                                                        <div className="mb-4">
                                                            <label className="form-label">
                                                                Passage ({lang.name}){lang.code === "en" && <sup className="text-danger">*</sup>}
                                                            </label>
                                                            <div className="quill-container">
                                                                <ReactQuill
                                                                    theme="snow"
                                                                    value={formval[fields.passage]}
                                                                    onChange={(content) => handleQuillChange(content, fields.passage)}
                                                                    modules={quillModules}
                                                                    formats={quillFormats}
                                                                    placeholder={`Enter the reading passage in ${lang.name}...`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}

                                    {/* Language Tabs */}
                                    <div className="language-tabs">
                                        {languages.map((lang) => (
                                            <div
                                                key={lang.code}
                                                className={`language-tab ${activeLanguage === lang.code ? "active" : ""}`}
                                                onClick={() => setActiveLanguage(lang.code)}
                                            >
                                                <span>{lang.flag}</span>
                                                <span>{lang.name}</span>
                                                <FontAwesomeIcon icon={faGlobe} />
                                            </div>
                                        ))}
                                    </div>

                                    {/* Language Content */}
                                    {languages.map((lang) => {
                                        const fields = getFieldNames(lang.code)
                                        return (
                                            <div
                                                key={lang.code}
                                                className={`language-content ${activeLanguage === lang.code ? "active" : ""}`}
                                            >
                                                <div className="row">
                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor={fields.question} className="form-label">
                                                            Question ({lang.name}){lang.code === "en" && <sup className="text-danger">*</sup>}
                                                        </label>
                                                        {formval.question_type === "math" && (
                                                            <div className="math-toolbar">
                                                                <button
                                                                    type="button"
                                                                    className="math-btn"
                                                                    onClick={() => {
                                                                        setActiveField(fields.question)
                                                                        setShowMathEditor(true)
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faCalculator} className="me-1" />
                                                                    Add Math
                                                                </button>
                                                            </div>
                                                        )}

                                                        {formval.question_type === "passage" ? (
                                                            <div className="quill-container">
                                                                <ReactQuill
                                                                    theme="snow"
                                                                    value={formval[fields.question]}
                                                                    onChange={(content) => handleQuillChange(content, fields.question)}
                                                                    modules={quillModules}
                                                                    formats={quillFormats}
                                                                    placeholder={`Enter your question in ${lang.name}...`}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <textarea
                                                                className="form-control question-textarea"
                                                                name={fields.question}
                                                                placeholder={`Enter your question in ${lang.name}${formval.question_type === "math" ? " (Use $$expression$$ for math)" : ""
                                                                    }`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.question]}
                                                            ></textarea>
                                                        )}
                                                    </div>

                                                    <div className="col-lg-6 mb-4">
                                                        <div className="option-container">
                                                            <span className="option-label">Option A ({lang.name})</span>
                                                            {formval.question_type === "math" && (
                                                                <div className="math-toolbar">
                                                                    <button
                                                                        type="button"
                                                                        className="math-btn"
                                                                        onClick={() => {
                                                                            setActiveField(fields.optionA)
                                                                            setShowMathEditor(true)
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCalculator} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fields.optionA}
                                                                placeholder={`Enter option A in ${lang.name}`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.optionA]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-4">
                                                        <div className="option-container">
                                                            <span className="option-label">Option B ({lang.name})</span>
                                                            {formval.question_type === "math" && (
                                                                <div className="math-toolbar">
                                                                    <button
                                                                        type="button"
                                                                        className="math-btn"
                                                                        onClick={() => {
                                                                            setActiveField(fields.optionB)
                                                                            setShowMathEditor(true)
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCalculator} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fields.optionB}
                                                                placeholder={`Enter option B in ${lang.name}`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.optionB]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-4">
                                                        <div className="option-container">
                                                            <span className="option-label">Option C ({lang.name})</span>
                                                            {formval.question_type === "math" && (
                                                                <div className="math-toolbar">
                                                                    <button
                                                                        type="button"
                                                                        className="math-btn"
                                                                        onClick={() => {
                                                                            setActiveField(fields.optionC)
                                                                            setShowMathEditor(true)
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCalculator} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fields.optionC}
                                                                placeholder={`Enter option C in ${lang.name}`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.optionC]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 mb-4">
                                                        <div className="option-container">
                                                            <span className="option-label">Option D ({lang.name})</span>
                                                            {formval.question_type === "math" && (
                                                                <div className="math-toolbar">
                                                                    <button
                                                                        type="button"
                                                                        className="math-btn"
                                                                        onClick={() => {
                                                                            setActiveField(fields.optionD)
                                                                            setShowMathEditor(true)
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCalculator} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fields.optionD}
                                                                placeholder={`Enter option D in ${lang.name}`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.optionD]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 mb-4">
                                                        <div className="option-container">
                                                            <span className="option-label">Option E ({lang.name}) - Optional</span>
                                                            {formval.question_type === "math" && (
                                                                <div className="math-toolbar">
                                                                    <button
                                                                        type="button"
                                                                        className="math-btn"
                                                                        onClick={() => {
                                                                            setActiveField(fields.optionE)
                                                                            setShowMathEditor(true)
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCalculator} />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={fields.optionE}
                                                                placeholder={`Enter option E in ${lang.name} (optional)`}
                                                                onChange={changeHandler}
                                                                value={formval[fields.optionE]}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 mb-4">
                                                        <label htmlFor={fields.explanation} className="form-label">
                                                            Explanation ({lang.name})
                                                        </label>
                                                        {formval.question_type === "math" && (
                                                            <div className="math-toolbar">
                                                                <button
                                                                    type="button"
                                                                    className="math-btn"
                                                                    onClick={() => {
                                                                        setActiveField(fields.explanation)
                                                                        setShowMathEditor(true)
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faCalculator} className="me-1" />
                                                                    Add Math
                                                                </button>
                                                            </div>
                                                        )}

                                                        <div className="quill-container">
                                                            <ReactQuill
                                                                theme="snow"
                                                                value={formval[fields.explanation]}
                                                                onChange={(content) => handleQuillChange(content, fields.explanation)}
                                                                modules={quillModules}
                                                                formats={quillFormats}
                                                                placeholder={`Enter explanation in ${lang.name}...`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                    {/* Correct Answer Section */}
                                    <div className="correct-answer-container">
                                        <div className="correct-answer-title">
                                            Select Correct Answer<sup className="text-danger">*</sup>
                                        </div>
                                        <div className="radio-container">
                                            <label className="radio-option">
                                                <input
                                                    type="radio"
                                                    name="correct_answer"
                                                    value="A"
                                                    onChange={changeHandler}
                                                    checked={formval.correct_answer === "A"}
                                                />
                                                Option A
                                            </label>
                                            <label className="radio-option">
                                                <input
                                                    type="radio"
                                                    name="correct_answer"
                                                    value="B"
                                                    onChange={changeHandler}
                                                    checked={formval.correct_answer === "B"}
                                                />
                                                Option B
                                            </label>
                                            <label className="radio-option">
                                                <input
                                                    type="radio"
                                                    name="correct_answer"
                                                    value="C"
                                                    onChange={changeHandler}
                                                    checked={formval.correct_answer === "C"}
                                                />
                                                Option C
                                            </label>
                                            <label className="radio-option">
                                                <input
                                                    type="radio"
                                                    name="correct_answer"
                                                    value="D"
                                                    onChange={changeHandler}
                                                    checked={formval.correct_answer === "D"}
                                                />
                                                Option D
                                            </label>
                                            <label className="radio-option">
                                                <input
                                                    type="radio"
                                                    name="correct_answer"
                                                    value="E"
                                                    onChange={changeHandler}
                                                    checked={formval.correct_answer === "E"}
                                                />
                                                Option E
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 text-center mt-4">
                                        <button type="submit" className="btn btn-for-add text-white" disabled={loading || fetchingData}>
                                            {loading && <div className="loading-spinner"></div>}
                                            <FontAwesomeIcon icon={faSave} className="me-2" />
                                            {loading ? "Saving..." : "Save Question"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Math Editor Modal */}
                {showMathEditor && (
                    <div className="math-editor-modal">
                        <div className="math-editor-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Math Expression Editor</h5>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => setShowMathEditor(false)}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">LaTeX Expression</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={mathExpression}
                                    onChange={(e) => setMathExpression(e.target.value)}
                                    placeholder="Enter LaTeX expression (e.g., x^2 + y^2 = z^2)"
                                />
                                {/* <small className="text-muted">
                                    Use LaTeX syntax. Example: x^2 for x², \frac{a}
                                    {b} for fractions, \sqrt{x} for square root
                                </small> */}
                            </div>

                            <div className="math-symbols">
                                {[
                                    { symbol: "\\alpha", display: "α" },
                                    { symbol: "\\beta", display: "β" },
                                    { symbol: "\\gamma", display: "γ" },
                                    { symbol: "\\delta", display: "δ" },
                                    { symbol: "\\pi", display: "π" },
                                    { symbol: "\\theta", display: "θ" },
                                    { symbol: "\\lambda", display: "λ" },
                                    { symbol: "\\mu", display: "μ" },
                                    { symbol: "\\sum", display: "Σ" },
                                    { symbol: "\\int", display: "∫" },
                                    { symbol: "\\frac{a}{b}", display: "a/b" },
                                    { symbol: "\\sqrt{x}", display: "√x" },
                                    { symbol: "x^2", display: "x²" },
                                    { symbol: "x_1", display: "x₁" },
                                    { symbol: "\\sin", display: "sin" },
                                    { symbol: "\\cos", display: "cos" },
                                    { symbol: "\\tan", display: "tan" },
                                    { symbol: "\\log", display: "log" },
                                    { symbol: "\\ln", display: "ln" },
                                    { symbol: "\\infty", display: "∞" },
                                    { symbol: "\\pm", display: "±" },
                                    { symbol: "\\times", display: "×" },
                                    { symbol: "\\div", display: "÷" },
                                    { symbol: "\\leq", display: "≤" },
                                    { symbol: "\\geq", display: "≥" },
                                    { symbol: "\\neq", display: "≠" },
                                    { symbol: "\\approx", display: "≈" },
                                    { symbol: "\\rightarrow", display: "→" },
                                ].map((item) => (
                                    <div
                                        key={item.symbol}
                                        className="math-symbol"
                                        onClick={() => setMathExpression((prev) => prev + item.symbol)}
                                        title={item.symbol}
                                    >
                                        {item.display}
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex gap-2 justify-content-end">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowMathEditor(false)}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => insertMathExpression(mathExpression)}
                                    disabled={!mathExpression.trim()}
                                >
                                    Insert Expression
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </>
    )
}
